import { Link } from 'react-router-dom';

export default function FeaturedGuide() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div
            className="order-2 lg:order-1 relative rounded-2xl overflow-hidden aspect-[4/3]"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20fashion%20discovery%20workspace%20with%20a%20tablet%20showing%20colorful%20product%20catalog%20on%20a%20light%20wooden%20desk%2C%20neatly%20arranged%20sneakers%20and%20accessories%20nearby%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%2C%20cream%20and%20soft%20beige%20aesthetic%2C%20cozy%20productive%20atmosphere%20with%20linen%20textures%2C%20editorial%20photography%20with%20gentle%20shadows%20and%20warm%20tones&width=800&height=600&seq=guide-card-v2&orientation=landscape"
              alt="Complete Sugargoo Spreadsheet Guide 2026"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
              Featured Guide
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              Complete Sugargoo Spreadsheet Guide{' '}
              <span className="text-primary-600">2026</span>
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                New to the world of Sugargoo Spreadsheet? Our comprehensive guide walks you through every
                aspect of using this powerful shopping tool — from understanding what it is and how it works,
                to advanced tips for finding hidden gems across every product category.
              </p>
              <p>
                Learn how to navigate the spreadsheet interface, understand product listings, use category
                filters effectively, and make smarter purchasing decisions. Whether you are a complete
                beginner or an experienced shopper looking to level up, this guide has something for everyone.
              </p>
              <ul className="space-y-2 mt-4">
                {[
                  'How to use Sugargoo Spreadsheet step by step',
                  'Tips for finding the best product deals',
                  'Understanding category organization',
                  'How to compare products efficiently',
                  'Common mistakes to avoid as a beginner',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <i className="ri-check-line text-accent-600 mt-0.5 flex-shrink-0"></i>
                    <span className="text-sm text-foreground-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-8">
              <Link
                to="/article/sugargoo-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Read the Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}